'use strict';


var storage = {},
    filename = 'applications-storage.json',
    originJson;


/* eslint new-cap: 0 */
/* eslint no-undef: 0 */
try {
    originJson = gSTB.LoadUserData(filename);
    storage = JSON.parse(originJson);
} catch ( error ) {
    if ( DEVELOP ) {
        debug('mag')('error json parse in storage ' + error);
    }
}


function Storage ( uid ) {
    // stalker storage
    this.store = {};

    Object.defineProperty(this, 'prefix', {
        get: function () {
            return uid + '.storage';
        }
    });

    this.originJSON = storage[this.prefix];

    if ( DEVELOP ) {
        debug('mag')('storage ' + this.prefix + ' contents: ' + this.originJSON);
    }

    if ( this.originJSON ) {
        try {
            this.store = JSON.parse(this.originJSON);
        } catch ( error ) {
            if ( DEVELOP ) {
                debug('mag')('storage ' + error);
            }
            this.originJSON = '';
        }
    }
}

window.addEventListener('unload', function () {
    if ( !NANOCORE ) {
        Storage.forceFlush();
    }
});


Storage.prototype.getItem = function ( key ) {
    return this.store[key];
};


Storage.prototype.setItem = function ( key, data ) {
    var serialazedData;

    try {
        serialazedData = JSON.stringify(data);
    } catch ( error ) {
        return;
    }

    if ( DEVELOP ) {
        debug('mag')('storage ' + this.prefix + ' set ' + key + ' with: ' + JSON.stringify(data));
    }

    this.store[key] = data;

    serialazedData = JSON.stringify(this.store);

    if ( serialazedData !== this.originJSON ) {
        if ( DEVELOP ) {
            debug('mag')('storage ' + this.prefix + ' updated');
            debug('mag')('storage ' + this.prefix + ' was ' + this.originJSON);
            debug('mag')('storage ' + this.prefix + ' now ' + serialazedData);
        }
        this.originJSON = serialazedData;
        storage[this.prefix] = this.originJSON;

        return;
    }

    if ( DEVELOP ) {
        debug('mag')('storage ' + this.prefix + ' not updated');
    }
};

Storage.forceFlush = function () {
    var json = JSON.stringify(storage);

    if ( DEVELOP ) {
        debug('mag')('storage json ' + json);
    }

    if ( DEVELOP ) {
        debug('mag')('storage originJson ' + originJson);
    }

    if ( originJson !== json ) {
        if ( DEVELOP ) {
            debug('mag')('storage saved');
        }
        window.gSTB.SaveUserData(filename, json);

        return;
    }

    if ( DEVELOP ) {
        debug('mag')('storage not saved');
    }
};


//function Storage ( uid ) {
//    this.store = {};
//
//    Object.defineProperty(this, 'prefix', {
//        get: function () {
//            return uid + '.storage';
//        },
//        set: function () {}
//    });
//
//    this.originJSON = window.stbStorage.getItem(this.prefix);
//
//    if ( this.originJSON ) {
//        try {
//            this.store = JSON.parse(this.originJSON);
//        } catch ( e ) {
//            this.originJSON = '';
//        }
//    }
//}
//
//
///**
// *
// * @param key data key
// */
//Storage.prototype.getItem = function ( key ) {
//    return this.store[key];
//};
//
//
///**
// *
// * @param key
// * @param data
// */
//Storage.prototype.setItem = function ( key, data ) {
//    var serialazedData;
//
//    try {
//        serialazedData = JSON.stringify(data);
//    } catch ( e ) {
//        return;
//    }
//
//    this.store[key] = data;
//
//    serialazedData = JSON.stringify(this.store);
//
//    if ( serialazedData !== this.originJSON ) {
//        this.originJSON = serialazedData;
//        window.stbStorage.setItem(this.prefix, this.originJSON);
//    }
//};


module.exports = Storage;
